import Icon from '@forwardflow/ui/Icons'
import { message, Select } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import { Account } from '../Account'
import useAuthUser from '@forwardflow/hooks/customHooks/useAuthUser'
import { useGetOrganizationList } from '@forwardflow/hooks/customHooks'
import { useEffect, useState } from 'react'
import LocalStorage from '@forwardflow/services/LocalStorage'
import OrganizationIcon from '@forwardflow/assets/svg/OrganizationIcon'
import { useSelectUserOrganizationModalStore } from '@forwardflow/store/modal/SelectUserOrganizationModal'
import { isOperatorEmail } from '@forwardflow/utils/app.utils'

export const Header: React.FC = () => {
   const location = useLocation()
   const currentPageUrl = location.pathname
   const [organizationParams, setOrganizationParams] = useState({
      page: 1,
      limit: 10,
   })
   const { openSelectUserOrganizationModal } =
      useSelectUserOrganizationModalStore()
   const selectedOrganization = LocalStorage.get(
      'currentOrganization'
   ) as string
   const { data: user } = useAuthUser({ revalidateOnMount: true })

   const onSelectOrganization = (value: string) => {
      try {
         LocalStorage.put('currentOrganization', value)
         message.success('Organization changed successfully')
         setTimeout(() => {
            window.location.href = '/onboarding'
         }, 1000)
      } catch (error) {
         console.log('error', error)
      }
   }

   const shouldFetch = isOperatorEmail(user?.email || '')

   const { data: organizationList, isLoading } = useGetOrganizationList({
      ...organizationParams,
      shouldFetch,
   })

   const loadMoreOrganizations = () => {
      setOrganizationParams((prev) => ({
         ...prev,
         page: prev.page + 1,
      }))
   }

   const [allOrganizations, setAllOrganizations] = useState<any[]>([])

   useEffect(() => {
      if (organizationList && organizationList.length > 0) {
         setAllOrganizations((prev) => {
            const combined = [...prev, ...organizationList]
            return Array.from(
               new Map(combined.map((item) => [item.id, item])).values()
            )
         })
      }
   }, [organizationList])

   const organizationOptions = allOrganizations?.map((item) => {
      return {
         value: item.id,
         label: item.organizationName + ' - ' + item.id,
      }
   })

   const currentOrganizationId = LocalStorage.get(
      'currentOrganization'
   ) as string

   const currentOrganizationObj = user?.userOrganizations?.find(
      (org) => String(org.organizationId) === currentOrganizationId
   )

   return (
      <header className="flex flex-wrap px-6 lg:px-11">
         <div className="flex items-center self-center order-1">
            <a className="shrink-0" href="#">
               <img
                  src="/images/ff-sm-logo.png"
                  className="w-8 lg:w-auto"
                  alt="forward-flow-logo"
               />
            </a>
         </div>
         {currentPageUrl === '/dashboard' && (
            <div className="flex items-center self-center order-3 w-full lg:w-auto lg:order-2">
               <Icon
                  name="Hamburger"
                  className="ml-3 cursor-pointer lg:hidden"
               />
               <div className="ml-6 lg:ml-16 lg:text-[24px] font-medium text-white/70">
                  Dashboard
               </div>
            </div>
         )}

         <div className="flex items-center justify-end flex-1 order-2 py-3 gap-x-4 lg:order-3 ">
            {user?.userOrganizations?.length === 1 ||
            user?.email === 'operator@forward-flow.com' ? null : (
               <div
                  onClick={openSelectUserOrganizationModal}
                  className=" h-[50px] flex items-center bg-white bg-opacity-[0.04] hover:bg-opacity-[0.08] p-2 rounded text-sm w-56 cursor-pointer"
               >
                  <span className="bg-[#27282C] rounded mr-6 flexc w-9 h-9">
                     <span className="scale-95">
                        <OrganizationIcon />
                     </span>
                  </span>
                  <span>
                     {currentOrganizationObj?.organization?.name ||
                        'Organization'}
                  </span>
               </div>
            )}
            {!currentPageUrl.includes('/demo-conversations') &&
               (user?.email === 'operator@forward-flow.com' ||
                  user?.email === 'brannon@forward-flow.com' ||
                  user?.email === 'engineered@forward-flow.com') && (
                  <Link
                     to="/demo-conversations"
                     className="bg-[#D9D9D9]/40 opacity-80 flexc h-12 border-white/30 border !m-0 !rounded !w-[120px] gap-x-3 hover:bg-[#D9D9D9]/60 hover:border-white"
                  >
                     <Icon name="Message" className=" fill-white" />
                     <span>Demo</span>
                  </Link>
               )}
            {(user?.email === 'operator@forward-flow.com' ||
               user?.email === 'brannon@forward-flow.com' ||
               user?.email === 'engineered@forward-flow.com') && (
               <>
                  <Select
                     className="ml-[10px] w-[120px] lg:w-[200px] dashboard-select"
                     placeholder="Select Organization"
                     options={organizationOptions}
                     onChange={onSelectOrganization}
                     value={selectedOrganization || ''}
                     loading={isLoading}
                     onPopupScroll={(e) => {
                        const target = e.target as HTMLDivElement
                        if (
                           target.scrollTop + target.offsetHeight >=
                           target.scrollHeight - 20
                        ) {
                           loadMoreOrganizations()
                        }
                     }}
                  />
               </>
            )}

            {/* {currentPageUrl === '/dashboard' && (
               <>
                  <div
                     onClick={openSearchModal}
                     className="flex items-center justify-center rounded-full cursor-pointer lg:hidden w-9 h-9 bg-white/10"
                  >
                     <Icon
                        name="search"
                        className="text-[#fff] scale-90 flexc"
                     />
                  </div>
                  <SearchField
                     onclick={openSearchModal}
                     className="hidden lg:flex"
                  />
               </>
            )} */}
            {/* <Notification /> */}
            <Account />
         </div>
      </header>
   )
}
